import type { SystemStyleObject } from '@companydotcom/potion';

const parts = ['container', 'divider', 'formButton', 'form'];

const baseStyleContainer: SystemStyleObject = {
  paddingTop: 14,
  paddingBottom: '80px',
  maxWidth: 776,
  marginX: 'auto',
  paddingX: 5,
};

const baseStyleDivider: SystemStyleObject = {};

const baseStyleFormButton: SystemStyleObject = {};

const baseStyleForm: SystemStyleObject = {
  backgroundColor: 'gray.50',
};

const baseStyle = () => ({
  container: baseStyleContainer,
  divider: baseStyleDivider,
  formButton: baseStyleFormButton,
  form: baseStyleForm,
});

export default {
  parts,
  baseStyle,
};
